import ordinal from './ordinal';

const months=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

const dateFormatter = (isoDateFormat) => {
	const [year,month,day]=isoDateFormat.split('-');
	const dayNum=parseInt(day,10);
	const monthNum = parseInt(month, 10)-1;
	return `${ordinal(dayNum)} ${months[monthNum]} ${year}`;
}

export default dateFormatter;